import request from './axiosFun';
import apiHttp from './apiHttp';
// 人员列表
var url = '';
if (process.env.NODE_ENV === 'development') {
  url = '/est';
} else {
  url = '';
}
//   获取镇名称
export function selectListPAreasInfo(data) {
  return apiHttp({
    url: url + '/pasture/sys/selectListPAreasInfo',
    method: 'post',
    data
  });
}
// 设备列表
export function getDsList(data) {
  return request({
    url: url + '/device/cameraDevice/getDsList',
    method: 'post',
    data
  });
}
// 设备列表(新2024-08-19 禁止检测张豪新增)
export function getDeviceAssociationsList(data) {
  return request({
    url: url + '/device/cameraDevice/getDeviceAssociationsList',
    method: 'post',
    data
  });
}
// 设备详情
export function detailApi(data) {
  return request({
    url: url + '/device/cameraDevice/dsView',
    method: 'post',
    data
  });
}
// 设备详情(新2024-08-19 禁止检测张豪新增)
export function queryDeviceInfoV2(data) {
  return request({
    url: url + '/device/cameraDevice/queryDeviceInfoV2',
    method: 'post',
    data
  });
}
// 禁止检测列表
export function getStaticMonitoringList(data) {
  return request({
    url: url + '/device/algorithm/getStaticMonitoringList',
    method: 'post',
    data
  });
}

// 修改设备
export function upCameraDevice(data) {
  return request({
    url: url + '/device/cameraDevice/upCameraDevice',
    method: 'post',
    data
  });
}
// 查询设备当天盘点历史

export function getDeviceCheckCount(data) {
  return request({
    url: url + '/device/algorithm/getDeviceCheckCount',
    method: 'post',
    data
  });
}

// 查询盘点算法坐标

export function findDeviceCoordinate(data) {
  return request({
    url: url + '/device/algorithm/findDeviceCoordinate',
    method: 'post',
    data
  });
}
// 修改盘点算法坐标
export function updateCheckDevice(data) {
  return request({
    url: url + '/device/algorithm/updateCheckDevice',
    method: 'post',
    data
  });
}
// 盘点值设置
export function openPushMsg(data) {
  return request({
    url: url + '/device/algorithm/openPushMsg',
    method: 'post',
    data
  });
}
// 静止值设置
export function updateThreshold(data) {
  return request({
    url: url + '/device/algorithm/updateThreshold',
    method: 'post',
    data
  });
}
// 获取第三方token
export function findSuperToken(query) {
  return request({
    url: url + '/device/cameraDevice/findSuperToken',
    method: 'post',
    data: query
  });
}
// 历史回放录像文件
export function getFileList(data) {
  return request({
    url: url + '/device/cameraDevice/getFileList ',
    method: 'post',
    data
  });
}
// 历史回放录像
export function getVideoPlayback(data) {
  return apiHttp({
    url: url + '/device/cameraDevice/getVideoPlaybackUrl',
    method: 'post',
    data
  });
}
// 历史异常记录
export function alarmlist(data) {
  return request({
    url: url + '/pasture/alarmlist/page',
    method: 'post',
    data
  });
}
// 设备直播地址
export function livingApi(data) {
  return request({
    url: url + '/livestock/livestockInfo/batchSuch',
    methods: 'post',
    data
  });
}
// 根据ID查询盘点信息   资产盘点日期
export function checkMsg(query) {
  return request({
    url: url + '/device/algorithm/getDeviceCheckCount',
    method: 'post',
    data: query
  });
}
// 查询用户设备当前盘点数量 暂时用不上
export function newcheckMsg(data) {
  return request({
    url: url + '/device/algorithm/getUserDeviceCheckCount',
    method: 'post',
    data: data
  });
}
// 查询设备直播地址(移动摄像头)
export function getDeviceLiveAddress(data, loading) {
  data.protocol = '2';
  const _request = loading ? apiHttp : request;
  return _request({
    url: url + '/device/cameraDevice/getVideoPlayUrl',
    method: 'post',
    data: data
  });
}
// 查询设备直播及回放地址(新摄像头地址)
export function getVideoHlsUrlToWeb(data, loading) {
  const _request = loading ? apiHttp : request;
  return _request({
    url: url + '/device/cameraDevice/getVideoHlsUrlToWeb',
    method: 'post',
    data: data
  });
}
// 初始设备列表
export function getUserDsList(data) {
  return request({
    url: url + '/device/cameraDevice/getUserDsList',
    method: 'post',
    data
  });
}
// 子洲初始设备列表
export function getNewUserDsList(data, loading) {
  const _request = loading ? apiHttp : request;
  return _request({
    url: url + '/device/cameraDevice/getAreaDeviceList',
    method: 'post',
    data
  });
}
// 是否推荐
export function suggestCamera(data) {
  return request({
    url: url + '/device/cameraDevice/suggestCamera',
    method: 'post',
    data
  });
}
// 查询字典
export function findDictList(query) {
  return apiHttp({
    url: url + '/base-server/homeCenter/sysInfo/findDictList',
    method: 'post',
    data: query
  });
}
// 查询字典
export function selectByAreas(query) {
  return apiHttp({
    url: url + '/pasture/sys/selectByAreas',
    method: 'post',
    data: query
  });
}



// WEBPACK FOOTER //
// ./src/api/device.js